import { useQuery } from '@tanstack/react-query';
import { getAxios } from '../../../lib/axios';
import { EntityNoteModel } from '../../../globalModels/entityNotes/entityNoteModel';
import { EntityNotesFilterModel } from '../types/entityNotesFilterModel';
import { CrmEndpoints } from '../../../constants/endpoints/crmEndpoints.ts';

export function useEntityNotesQuery(filterModel: EntityNotesFilterModel, id?: number) {
  // Ensure EntityNoteTypes is always an array (empty array if undefined)
  const cleanedFilter = {
    ...filterModel,
    EntityNoteTypes: filterModel.EntityNoteTypes || []
  };

  return useQuery({
    queryKey: ['entitynotesquery', cleanedFilter, id],
    retry: false,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    gcTime: 1,
    queryFn: async () =>
      (await getAxios().post<Array<EntityNoteModel>>(`${CrmEndpoints.EntityNotes.list(id)}`, cleanedFilter)).data
  });
}
